var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagementAndGovernance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-slug-id": "building06",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60815 48.7595H45.4751V11.3882H3.60815V48.7595Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.500244 48.7559H48.4565V43.6445H0.500244V48.7559Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71582 41.112H11.7523V18.376H6.71582V41.112Z",
    fill: "#50E6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2959 41.112H19.3324V18.376H14.2959V41.112Z",
    fill: "#50E6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8762 41.112H26.9127V18.376H21.8762V41.112Z",
    fill: "#50E6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5403 41.112H34.5768V18.376H29.5403V41.112Z",
    fill: "#50E6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1201 41.112H42.1566V18.376H37.1201V41.112Z",
    fill: "#50E6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.53418 15.8746H48.4651V10.7127L23.788 0.927734L0.53418 10.7127V15.8746Z",
    fill: "#0078D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementAndGovernance);
export default __webpack_public_path__ + "static/media/management_and_governance.ccb07e33628bf94735b5163b9dcfbac9.svg";
export { ForwardRef as ReactComponent };